"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";
import clsx from "clsx";

type DesktopContactBtnProps = {
	href: string;
	label: string;
	className?: string;
	btnInsideClassName?: string;
};

export default function DesktopContactBtn({ href, label, className = "", btnInsideClassName = "" }: DesktopContactBtnProps) {
	const pathname = usePathname();
	const isActive = pathname === href;

	const content = (
		<div className="relative flex h-full items-center gap-2">
			<span
				className={clsx(
					"text-cap-m transition-colors duration-300 ease-in-out",
					isActive ? "text-navy-blue-light" : "text-navy-blue-deep",
					!isActive && "group-hover:text-navy-blue-light",
					btnInsideClassName,
				)}
			>
				{label}
			</span>
			<span
				className={clsx(
					"block h-[0.43rem] w-[0.43rem] rounded-full",
					"transition-colors duration-300 ease-in-out",
					isActive ? "bg-navy-blue-light" : "bg-navy-blue-deep",
					!isActive && "group-hover:bg-navy-blue-light",
				)}
			/>
		</div>
	);

	return (
		<Link
			href={href}
			className={clsx(
				"group relative w-fit",
				"transition-all duration-300 ease-in-out",
				"px-[1.074rem] pt-[0.859rem] pb-3",
				isActive ? "bg-navy-blue-deep rounded-[1.611rem]" : "bg-navy-blue-light rounded-[0.269rem]",
				!isActive && "hover:bg-navy-blue-deep hover:rounded-[1.611rem]",
				className,
			)}
		>
			{content}
		</Link>
	);
}
